var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOverview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M1 2.81c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m0 5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m1 4c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1M5 1.81c0 .55.482 1 1.071 1H18.93c.589 0 1.071-.45 1.071-1s-.482-1-1.071-1H6.07C5.482.81 5 1.26 5 1.81m0 5c0 .55.482 1 1.071 1H18.93c.589 0 1.071-.45 1.071-1s-.482-1-1.071-1H6.07c-.589 0-1.071.45-1.071 1m1.071 6c-.589 0-1.071-.45-1.071-1s.482-1 1.071-1H18.93c.589 0 1.071.45 1.071 1s-.482 1-1.071 1z",
  clipRule: "evenodd"
})));
export { SvgOverview as ReactComponent };
export default __webpack_public_path__ + "17f65543c670e6280a5421cbb56bddf7.svg";